import { render } from "./NoParcelsChecked.vue?vue&type=template&id=d06cfbaa&ts=true"
import script from "./NoParcelsChecked.vue?vue&type=script&lang=ts"
export * from "./NoParcelsChecked.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__